import * as cx from 'classnames';
import ModalLoadable from 'mk2/components/ModalLoadable';
import * as React from 'react';
import styles from './Modal.mscss';

interface OwnProps {
    className?: string;
    show: boolean;
    onHide?: () => void;
    onShow?: () => void;
}

class Modal extends React.Component<OwnProps> {

    public render() {
        const { className, children, ...rest } = this.props;

        return (
            <ModalLoadable className={cx(styles.Modal, className)} {...rest} backdropClassName={styles.Modal__backdrop}>
                {children}
            </ModalLoadable>
        );
    }

}

export default Modal;
